<template>
  <vc-tutorial :default-open="defaultOpen" @close="handleClose">
    <div class="vc-tutorial__content">
      <vc-tutorial-carousel class="vc-carousel" @close="handleClose">
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              <span>Tarefas essenciais</span>
            </h2>
            <small
              >Complete as tarefas para finalizar a configuração inicial do
              Finanças</small
            >
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Tarefas" :src="tarefa" />
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>Mantenha as <span>Rotinas</span></h2>
            <small>Ganhe pontos sempre que concluir uma tarefa essencial</small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Níveis" :src="combos" />
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>Alcance novos <span>níveis</span></h2>
            <small
              >Complete rotinas e acumule combos para alcançar uma gestão
              360</small
            >
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Rotinas" :src="nivel" />
          </div>
        </li>
      </vc-tutorial-carousel>
    </div>
  </vc-tutorial>
</template>

<script setup lang="ts">
import tarefa from "./Images/MinhaGestao/tarefa.gif";
import combos from "./Images/MinhaGestao/combos.gif";
import nivel from "./Images/MinhaGestao/nivel.gif";
import { ETutorialGameficacaoKeys } from "@/features/financas/views/minhaGestao/modules/home/gameficacao/types";
import useStorage from "@/core/plugins/useStorage";

defineProps<{
  defaultOpen: string;
}>();

const storage = useStorage();

function handleClose() {
  storage.set(ETutorialGameficacaoKeys.realizouTutorialGameficacao, true);
}
</script>

<style lang="scss">
@import url("./style.scss");
</style>
